const brand = sessionStorage.getItem('brand');
export const settings = {
  myAccount: '我的账户',
  yourProfileAndPasswordSecurity: '您的个人资料和密码安全',
  detailsHeader: '详细信息',
  passwordHeader: '密码',
  customAttributeHeader: '自定义属性',
  tagsHeader: '标签',
  accessTokenHeader: '访问令牌',
  thirdPartyIntegrationsHeader: '第三方集成',
  appTooltip: {
    TOOLTIP_DETAILS_HEADING: '更新您的账户配置文件',
    TOOLTIP_PASSWORD_HEADING: '更改您的密码',
    TOOLTIP_TAGS_HEADING: '管理您的标签',
    TOOLTIP_THIRD_PARTY_HEADING: '第三方集成',
    TOOLTIP_CHANGE_PASSWORD_TITLE: `安全的密码有助于保护您的 ${brand} 账户`,
    TOOLTIP_INTEGRATIONS: '集成',
    TOOLTIP_ADD_UPDATE_CUSTOM_ATTRIBUTE: '添加或更新自定义属性',
    TOOLTIP_CUSTOM_ATTRIBUTES: '管理您的自定义属性'
  },
  accessToken: {
    accessToken: '访问令牌',
    generateYourAccessTokenForUsingPlatformAPIs: `生成您的访问令牌以使用平台API`,
    generateApiToken: '生成API令牌',
    revokeApiToken: '撤销API令牌',
    regenerateApiToken: '重新生成API令牌',
    placeholders: {
      yourApiKey: '您的API密钥',
    }
  },
  details: {
    name: '姓名',
    emailId: '电子邮件ID',
    yourPlan: '您的计划',
    messagesPerMonth: '每月消息',
    daysOfStoragePlan: '存储计划天数',
    conditionalFeatures: '条件功能',
    upgradeToEnterprisePlanToGetMore: '升级至企业计划以获取更多',
    featuresAndStorageCapacity: '功能和存储容量',
    upgradePlan: '升级计划',
    submit: '提交',
    selectLanguage: '选择语言',
    baby: '初级',
    king: '高级',
    conversationsperMonth: '每月对话',
    english: '英语',
    hindi: '印地语',
    german: '德语',
    french: '法语',
    portuguese: '葡萄牙语',
    spanish: '西班牙语',
    italian: '意大利语',
    russian: '俄语',
    chatBotBrandName: '聊天机器人品牌名称',
    placeholders: {
      john: 'John',
      email: '电子邮件',
      searchLanguage: '搜索语言',
      chatBotBrandName: '聊天机器人品牌名称',
      brandWebsiteUrl: 'www.yourbrand.com',
      agencyName: 'Lookup Technologies',
      phoneNumber: '9876543210',
      agencySupportEmail: 'support@yourbrand.com',
      agencyContactPersonName: 'Kevin Peterson',
      agencyContactPersonEmailId: 'kevin@yourbrand.com'
    },
    appTooltip: {
      TOOLTIP_NAME: '输入您的个人资料名称',
      TOOLTIP_EMAIL_ADDRESS: '输入您的电子邮件地址',
    },
    changeEmail: {
      changeLabel: '更改',
      sendVerificationCodeModal: {
        changeEmail: '更改电子邮件',
        changeEmailDescription: '输入您要在将来使用的新电子邮件地址',
        newEmailLabel: '新电子邮件ID',
        changeEmailPlaceholder: '输入新电子邮件',
        sendVerificationCode: '发送验证码'
      },
      verifyEmailModal: {
        verifyEmail: '验证电子邮件！',
        verifyDescription: '我们已将验证码发送到您已注册的现有电子邮件。',
        checkSpam: '没有收到电子邮件？请检查您的垃圾邮件文件夹',
        labelText: '输入4位代码',
        submitText: '提交',
        resendText: '重新发送代码'
      }
    },
    myAccountDetails: {
      brandDetails: '品牌详情',
      brandName: '品牌名称',
      brandWebsiteUrl: '品牌网站URL',
      brandLogo: '品牌标志',
      agencyDetails: '机构详情',
      agencyName: '机构名称',
      agencyPhoneNumber: '机构电话号码',
      agencyEmailId: '机构电子邮件ID',
      contactPersonDetails: '联系人详情',
      contactName: '联系人姓名',
      phoneNumber: '电话号码',
      contactEmailId: '电子邮件ID',
      updateDetails: '更新详情'
    },
  },
  customAttribute: {
    addAttribute: '添加属性',
    discard: '丢弃',
    customAttribute: '自定义属性',
    checkOrAddCustomAttribute: '在此处，您可以检查并添加自定义属性。',
    attributeKey: '属性键',
    attributeName: '属性名称',
    bot: '机器人',
    flow: '流',
    loadMore: '加载更多',
    question: '问题',
    action: '操作',
    search: '搜索',
    selectBot: '选择机器人',
    selectFlow: '选择流',
    selectQuestion: '选择问题',
    noDataFoundHeading: '您尚未创建任何属性',
    noDataFoundSubheading: '所有您的属性都将显示在此处',
    deleteTitle: '删除属性',
    deleteDescription: '您确定要删除此属性吗？',
    deleteAttributes: '删除属性',
    areYouSureYouWantToDeleteThisAttributes: '您确定要删除此属性吗？',
    editAttribute: '编辑属性',
    headsUp: '提醒',
    okay: '确定',
    dataAddedToLead:
      '映射到您的API或Bot Flows的属性将不会更新。请相应地更新API或Bot Flows。',
    placeholders: {
      enterAttributeKey: '输入属性键',
      enterAttributeName: '输入属性名称',
      selectBot: '选择机器人',
      selectFlow: '选择流',
      selectQuestion: '选择问题',
      search: '按属性名称搜索',
    },
    appToolTip: {
      TOOLTIP_ATTRIBUTE_KEY: '输入属性键',
      TOOLTIP_ATTRIBUTE_NAME: '输入属性名称',
      TOOLTIP_SELECT_BOT: '选择机器人',
      TOOLTIP_SELECT_FLOW: '选择流',
      TOOLTIP_SELECT_QUESTION: '选择问题',

    }
  },
  password: {
    changePassword: '更改密码',
    aSecurePasswordHelpsProtectYour: '安全的密码有助于保护您的',
    account: ' 帐户',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    cancel: '取消',
    updatePassword: '更新密码',
    deleteAccount: '删除账户',
    placeholders: {
      enterYourCurrentPassword: '输入您的当前密码',
      enterYourNewPassword: '输入新密码',
      enterYourConfirmPassword: '输入确认密码',
    },
    appTooltip: {
      TOOLTIP_CURRENT_PASSWORD: '输入旧密码',
      TOOLTIP_NEW_PASSWORD: '输入新密码',
      TOOLTIP_CONFIRM_PASSWORD: '确认新密码',
      TOOLTIP_DELETE_ACCOUNT: `删除您当前的 ${brand} 帐户`,
    }
  },
  tags: {
    manageTags: '管理标签',
    createNewTags: '创建新标签',
    createNewTagsSubText: '在此处管理您的标签，以更好地组织潜在客户、聊天、群组等',
    tagName: '标签名称',
    updateTag: '更新标签',
    createTag: '创建标签',
    discard: '丢弃',
    searchTag: '按名称搜索标签',
    noTagFound: '未找到标签！',
    createATag: '创建标签',
    deleteTagModalSubText: '您确定要删除此标签吗？删除此标签还将从已分配的用户中删除此标签！',
    deleteTagModalHeading: '删除标签',
    deleteOneTagModalHeading: '删除标签',
    actions: '操作',
    placeholders: {
      enterTag: '输入标签名称',
    },
    appTooltip: {
      TOOLTIP_DELETE_TAGS: '删除标签',
      TOOLTIP_MANAGE_TAGS: '管理您的标签',
    }
  },
  thirdPartyIntegration: {
    list: {
      name: '名称',
      status: '状态',
      action: '操作',
      messageBird: 'MessageBird',
      messageBirdForSendingMessagesAndEmails: 'MessageBird 用于发送消息和邮件',
      notConnected: '未连接',
      connected: '已连接',
      edit: '编辑',
      plivo: 'Plivo',
      plivoForSendingMessages: 'Plivo 用于发送消息',
      connect: '连接',
      appTooltip: {
        nameOfAppOrCrm: '应用/CRM 的名称',
        statusAsConnectedOrNotConnected: '连接状态/未连接状态',
        clickToConnectAppOrCrm: '单击以连接应用/CRM',
      },
      upgradeModal: {
        oopsIntegrationsAreNotAvailableForBabyPlan: '糟糕！集成在 Baby 计划中不可用。请升级到 King 计划以使用集成功能。',
      }
    },
    providers: {
      messageBird: {
        messageBird: 'MessageBird',
        integrateWithMessageBird: '与 MessageBird 集成',
        apiKey: 'API 密钥',
        originator: '发起人',
        connect: '连接',
        disconnect: '断开连接',
        seeActivities: '查看活动',
        sms: '短信',
        time: '时间',
        phoneNumber: '电话号码',
        status: '状态',
        botName: '机器人名称',
        message: '消息',
        error: '错误',
        placeholders: {
          apiKey: 'API 密钥',
          messageBirdPhoneNumber: 'MessageBird 电话号码',
        },
        noDataFound: {
          activities: '活动',
          noActivitiesFound: '找不到任何活动！',
        }
      },
      plivo: {
        plivo: 'Plivo',
        integrateWithPlivo: '与 Plivo 集成',
        authId: '身份验证 ID',
        authToken: '身份验证令牌',
        yourPlivoPhoneNumber: '您的 Plivo 电话号码',
        connect: '连接',
        disconnect: '断开连接',
        seeActivities: '查看活动',
        sms: '短信',
        time: '时间',
        phoneNumber: '电话号码',
        status: '状态',
        botName: '机器人名称',
        message: '消息',
        error: '错误',
        noDataFound: {
          activities: '活动',
          noActivitiesFound: '找不到任何活动！',
        },
        placeholders: {
          authId: '身份验证 ID',
          authToken: '身份验证令牌',
          yourPlivoPhoneNumber: '您的 Plivo 电话号码',
        }
      }
    }
  }
};
